import { Component, OnInit } from '@angular/core';
import { SemKeywordsV1Component } from './../sem-keywords-v1/sem-keywords-v1.component';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetLibraryService } from '../../services/widget-library.service';

@Component({
	selector: 'app-sem-keywords-v4',
	templateUrl: './sem-keywords-v4.component.html',
	styleUrls: ['./sem-keywords-v4.component.css']
})
export class SemKeywordsV4Component extends SemKeywordsV1Component implements OnInit {
	objectKeys = Object.keys;

	ngOnInit() {
		super.ngOnInit();
	}
}
